import React, { useContext } from 'react';
import Typography from '@mui/material/Typography';
import Badge from '@mui/material/Badge';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import LocalGroceryStoreIcon from '@mui/icons-material/LocalGroceryStore';
import RemoveShoppingCartIcon from '@mui/icons-material/RemoveShoppingCart';
import { Context} from '../../store/Context';

function ProductCard({ 
    product, 
    add,   
    removeCategory 
}) {        
    const { count } = product;
    const { contextState: {         
        currencyIcon
    } } = useContext( Context );    
    return (
        <Grid item xs={12} md={6}>           
            <Card sx={{ display: 'flex', height: 200 }}>
                <CardContent sx={{ flex: 1, position: 'relative' }}>
                    <Typography component="h5" variant="h5" color="black" style={{ fontWeight: 600 }}>
                        {product.name}
                    </Typography>           
                    <Typography component="h6">
                        {product.description}
                    </Typography>   
                    <Typography variant="h5" color="blue" sx={{position: 'absolute', fontSize: 18, fontWeight: 600, bottom: 60, right: 10 }}>
                        {currencyIcon} {product.price}
                    </Typography>           
                    <CardActions sx={{position: 'absolute', bottom: 0, left: 0}}>
                        <IconButton 
                            aria-label="Add to Cart"
                            onClick={() => add(product)}
                        >
                            <AddShoppingCartIcon />
                        </IconButton>      
                        { (count > 0) && <IconButton
                            size="large"
                            aria-label={`Products in basket: ${count}`}
                            color="inherit"
                            aria-describedby={`count-${count}`}                             
                            onClick={() => removeCategory(product.id)}
                        >                          
                            <RemoveShoppingCartIcon />
                        
                        </IconButton>}                                         
                        { (count > 0) && <IconButton
                            size="large"
                            aria-label={`Products in basket: ${count}`}
                            color="inherit"
                            aria-describedby={`count-${count}`}                             
                        >
                            <Badge badgeContent={count} color="success">
                                <LocalGroceryStoreIcon />
                            </Badge>
                        </IconButton>}                               
                    </CardActions>
                </CardContent>     
                <CardMedia
                    component="img"
                    sx={{ width: 160, display: { xs: 'none', sm: 'block' } }}
                    image={product.img}
                    alt={product.name}
                />     
               
            </Card>           
        </Grid>
    );
}

export default ProductCard;
